import React from "react";
import { Outlet } from "react-router-dom";

export const AnonymousLayout: React.FC = () => {
  return <Outlet />;
};

export default AnonymousLayout;

